module.exports = __webpack_public_path__ + "static/media/item-activity.96309505.png";